/* eslint-disable consistent-return */
import { Meteor } from 'meteor/meteor';
import rateLimit from '../../modules/rate-limit';

import {
  fetchOne,
  insert,
  update,
  copy,
  softDelete,
  restore,
  hardDelete,
  toggleSharedLayerData,
  toggleSharedPrivateLayerData,
  updateMapLocation,
  updateAnnotationsRealTime,
  updateStyle,
  getTokenVersion,
  loadFiware,
  loadFiwareAttributes,
  loadFiwareLayers,
  loadGoogleSheets,
  loadOGRGeoJSON,
  loadPostgreSQL,
  loadPostgreSQLAttributes,
  loadCatalogo
} from './server/layer-methods-server';

Meteor.methods({
  'layers.fetchOne'(layerId) {
    return fetchOne(layerId);
  },
  'layers.insert'(layer, userId = this.userId) {
    return insert(layer, userId);
  },
  'layers.update'(layer) {
    return update(layer);
  },
  'layers.copy'(layerId) {
    return copy(layerId, this.userId);
  },
  'layers.softDelete'(layerId) {
    softDelete(layerId);
  },
  'layers.restore'(layerId) {
    restore(layerId);
  },
  'layers.hardDelete'(layerId) {
    return hardDelete(layerId);
  },
  'layers.toggleSharedLayerData'(graphicId, isShared) {
    return toggleSharedLayerData(graphicId, isShared);
  },
  'layers.toggleSharedPrivateLayerData'(graphicId, isShared) {
    return toggleSharedPrivateLayerData(graphicId, isShared);
  },

  'layers.updateMapLocation'(layerId, newMapLocation) {
    return updateMapLocation(layerId, newMapLocation);
  },
  'layers.updateAnnotationsRealTime'(layerId, newAnnotationsId) {
    return updateAnnotationsRealTime(layerId, newAnnotationsId);
  },
  'layers.updateStyle'(layerId, newStyleId) {
    return updateStyle(layerId, newStyleId);
  },
  'layers.getTokenVersion'(connectionParameters) {
    return getTokenVersion(connectionParameters);
  },
  'layers.loadFiware'(loadParameters) {
    return loadFiware(loadParameters);
  },
  'layers.loadFiwareLayers'(loadParameters) {
    return loadFiwareLayers(loadParameters);
  },
  'layers.loadFiwareAttributes'(loadParameters) {
    return loadFiwareAttributes(loadParameters);
  },
  'layers.loadGoogleSheets'(loadParameters) {
    return loadGoogleSheets(loadParameters);
  },
  'layers.loadOGRGeoJSON'(loadParameters) {
    return loadOGRGeoJSON(loadParameters);
  },
  'layers.loadPostgreSQL'(loadParameters) {
    return loadPostgreSQL(loadParameters);
  },
  'layers.loadPostgreSQLAttributes'(loadParameters) {
    return loadPostgreSQLAttributes(loadParameters);
  },
  'layers.loadCatalogo'(loadParameters) {
    return loadCatalogo(loadParameters);
  }
});

rateLimit({
  methods: [
    'layers.insert',
    'layers.update',
    'layers.copy',
    'layers.softDelete',
    'layers.restore',
    'layers.hardDelete',
    'layers.toggleSharedLayerData',
    'layers.toggleSharedPrivateLayerData'
  ],
  limit: 5,
  timeRange: 1000
});
